import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { NFLookupBankAccount } from "../../../../Shared/NewForms/NFLookupBankAccount";
import { NFLookupVendorCustomer } from "../../../../Shared/NewForms/NFLookupVendorCustomer";
import { NFLookupContract } from "../../../../Shared/NewForms/NFLookupContract";
import { useFormContext } from "react-hook-form";

const ExpenseCashsPaymentToVendorDetail = () => {
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();
  const { watch } = useFormContext();

  const handleListChange = (selectedOption: number) => {
    if (selectedOption === 0) {
      setShowModal(true);
    } else if (selectedOption === 1) {
      setShowModal(false);
    }
  };
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFLookupBankAccount fieldName="bankAccountId" title={t("BankAccount")} />
        </Col>
        <Col sm={6}>
          <NFLookupVendorCustomer fieldName="vendorCustomerId" title={t("VendorsAndCustomers")} required />
        </Col>
      </Row>
        <Row>
          <Col sm={6}>
            <NFLookupContract fieldName="contractId" title={t("Contract")} />
          </Col>
        </Row>
    </>
  );
};

export default ExpenseCashsPaymentToVendorDetail;
